import React from "react";
import { Col, Container, Row } from "reactstrap";

const MainLayout = ({ children }) => (
  <React.Fragment>{children}</React.Fragment>
);

export default MainLayout;
